import { Component, OnInit } from '@angular/core';
import { IKCard, KCardFieldType , IKCardEvent} from 'ng-k-card';
import { KIconType } from 'ng-k-icon';
import { IKMenuButton } from 'ng-k-button';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { Router } from '@angular/router';
import { ClaimsService } from '../../../services/claims.service';
import { HttpClient } from '@angular/common/http';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import * as moment from 'moment';
import { Form, FormBuilder } from '@angular/forms';
import { OAuthService } from 'angular-oauth2-oidc';
import { OauthPlusService } from 'src/app/services/oauth-plus.service';

@Component({
  selector: 'app-claims-dashboard',
  templateUrl: './claims-dashboard.component.html',
  styleUrls: ['./claims-dashboard.component.scss']
})
export class ClaimsDashboardComponent implements OnInit {
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public allClaims = [];
  public cardData: IKCard = {};
  public allCards: any = [];

  // Pagination
  public page = 1;
  public limit = 24;
  public filter: any = {};

  public throttle = 300;
  public scrollDistance = 0.5;
  public scrollUpDistance = 0.5;

  // Form
  public searchClaimsFilterForm: any;
  constructor(
    private router: Router,
    private claimsService: ClaimsService,
    private http: HttpClient,
    private authService: OAuthService,
    private loaderService: GlobalLoadingService,
    private fb: FormBuilder,
    private _auth: OauthPlusService,
  ) { }

  ngOnInit(): void {
    // this.authService.getBasicAuthorization().subscribe((data)=> {
    //   console.log(data);
    // });
    // console.log(this.authService);
    this.searchClaimsFilterFormValidation();
     this._auth.$whenUserLoaded.subscribe((data: any)=> {
      if(data) {
        this.getAllClaims(this.page, this.limit, null);
      }
    });
  }

  searchClaimsFilterFormValidation() {
    this.searchClaimsFilterForm = this.fb.group({
      keyword: '',
      // gender: '',
      // claimant: ''
    });
  }

  submit_searchClaimsFilterForm(form: any) {
    const thisObj = this;
    if (form.status === 'VALID') {
      this.filter.searchKeyword = form.value.keyword;
      this.allClaims = [];
      this.allCards = [];
      thisObj.page = 1;
      thisObj.limit = this.limit;
      thisObj.getAllClaims(this.page, this.limit, thisObj.filter);
    }
  }

  resetSearchClaimFilterForm(form: any) {
    const thisObj = this;
    if (form.status === 'VALID') {
      form.reset();
      this.filter.searchKeyword = '';
      this.allClaims = [];
      this.allCards = [];
      thisObj.page = 1;
      thisObj.limit = this.limit;
      thisObj.getAllClaims(this.page, this.limit, null);
    }
  }

  getAllClaims(page: any, limit: any, filter?: any, isDelete?: boolean) {
    this.loaderService.startLoadingIndicator('getAllClaims');
    const thisObj = this;
    const requestParam: any = {};
    // requestParam.Authorization = 'Bearer '+ sessionStorage.getItem('access_token');

    // Pagination
    requestParam.page = this.page;
    requestParam.limit = limit;
    // Pagination

    // Filter
    if (filter) {
      requestParam.keyword = filter.searchKeyword ? filter.searchKeyword : '';
      // let a = {
      //   "claimant" : "cl28",
      //   "gender" : "male",
      // }
      // requestParam.keywordJson =  JSON.stringify(a);
    }
    // Filter

    // thisObj.claimsService.getAllClaims(requestParam.subscribe({
    //   next: (result: any) => console.log(result),
    //   error: (e: any) => console.error(e),
    //   complete: () => console.info('complete')
    // }));

    thisObj.claimsService.getAllClaims(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        // thisObj.allClaims = [];
        this.loaderService.stopLoadingIndicator('getAllClaims');
          thisObj.allClaims = result.data.claims;
          result.data.claims.forEach((data: any, index: number) => {
            // console.log(data);
            this.cardData = {
              value: data.id,
              header: {
                label: moment(new Date(data.createdAt)).format('DD/MM/YYYY'),
                labelColour: data?.status==1 ? 'brand-main' : 'red',
                icon: {
                  type: KIconType.fas,
                  name: 'clock'
                },
              },
              clickable: data?.status==1 ? true : false,
              cardClass: data?.status==1 ? 'activeCard' : 'deletedCard',
              cornerIndicatorColour: data?.status==0 ? 'red' : '',
              fields: [
                {
                  fieldType:  KCardFieldType.IdRef,
                  label: 'Reference',
                  value: (data?.data?.claimDetails?.claimReference? data?.data?.claimDetails?.claimReference : ' ' ),
                  icon: {
                    type: KIconType.fas,
                    name: 'tag',
                    border: true
                  }
                },
                {
                  fieldType:  KCardFieldType.Text,
                  label: 'Claimant',
                  value: (data?.data?.claimantDetails?.claimantFirstName? data?.data?.claimantDetails?.claimantFirstName : ' ' )  + ' ' + 
                  (data?.data?.claimantDetails?.claimantLastName? data?.data?.claimantDetails?.claimantLastName : ' ' ),
                  icon: {
                    type: KIconType.fas,
                    name: 'user',
                    border: true
                  }
                },
                {
                  fieldType:  KCardFieldType.Text,
                  label: 'Condition',
                  value: data.dsUsecase.usecaseTitle,
                  icon: {
                    type: KIconType.fas,
                    name: 'stethoscope',
                    border: true
                  }
                },
                {
                  fieldType: KCardFieldType.Text,
                  label: 'Last updated',
                  value: moment(new Date(data.updatedAt)).format('DD/MM/YYYY'),
                  icon: {
                    type: KIconType.fas,
                    name: 'business-time',
                    border: true
                  }
                }
              ]
            }
            this.allCards.push(this.cardData);
          });
          this.scrollInfiniteFix(result.data.total, this.allCards.length)
      }
    }, err => {     
    });

    // this.http.get('http://10.100.118.194:3000/api/v1/claims').subscribe((data:any) => {
    //   // this.addListData(schema); // adding dropdown field options
    //   // this.wizardData = this.mapper.mapToWizard(schema, this.wizardId);
    //   console.log(data);
    //   this.allClaims = data.rows;
    //   // console.log(thisObj.allClaims)
    // });    
  }

   /**
   *  scrollInfiniteFix
   * @param fullCount 
   * @param loadedCount 
   */
   public scrollInfiniteFix(fullCount: any, loadedCount: any) {
    if (loadedCount < fullCount) {
      document.documentElement.style.height = '101%';
    } else {
      this.scrollInfiniteFixReset();
    }
  }

  /**
   *  scrollInfiniteFixReset
   */
  public scrollInfiniteFixReset() {
    document.documentElement.style.height = '100%';
  }

  /**
   * Scroll Down
   *
   */
  onScrollDown() {
    this.loadMore();
  }

  /**
   * Load More
   *
   */
  loadMore() {
    this.page++;
    // console.log(this.searchClaimsFilterForm.value.keyword)
    this.getAllClaims(this.page, this.limit, this.searchClaimsFilterForm.value.keyword);
  }

  createNewClaim() {
    this.router.navigate(['/claimForm']);
  }

  cardEvent($event: IKCardEvent, card: any) {
    let cardId = card.value
    this.router.navigate(['/claimDetail/',cardId]);
  }

  headerMenuItemClick($event: any) {
    if ($event.actionValue == 'edit') {
      this.router.navigate(['/claimForm']);
    }
  }
}
